export default __webpack_public_path__ + "static/media/brand_img02.c77ac606.png";